module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('li', {
    staticClass: "cursor-pointer p-2 px-4 hover:underline"
  }, [_c('router-link', {
    staticClass: "text-blue-darkest pl-8 no-underline block",
    attrs: {
      "to": _vm.to
    }
  }, [_vm._t("default")], 2)], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-9e3b02aa","hasScoped":false}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/navbar/sidemenu/MenuItemLink.vue
// module id = 609
// module chunks = 66